export default function PuzzleControls({
  onCheck,
  onHint,
  onReset,
  statusMessage,
  tone = 'neutral',
  hintDisabled = false,
}) {
  const toneClasses = {
    neutral: 'border-slate-200 bg-slate-50 text-slate-700',
    success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    warning: 'border-amber-200 bg-amber-50 text-amber-700',
    error: 'border-rose-200 bg-rose-50 text-rose-700',
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          onClick={onCheck}
          className="rounded-full bg-brand-cyan px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-magenta"
        >
          Check progress
        </button>
        <button
          type="button"
          onClick={onHint}
          disabled={hintDisabled}
          className="rounded-full bg-slate-200 px-5 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-300 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Get hint
        </button>
        <button
          type="button"
          onClick={onReset}
          className="rounded-full border border-rose-200 px-5 py-2.5 text-sm font-semibold text-rose-600 transition hover:bg-rose-50 sm:col-span-2"
        >
          Reset puzzle
        </button>
      </div>
      <div className={`rounded-2xl border px-4 py-3 text-sm ${toneClasses[tone]}`}>
        {statusMessage || 'Your progress is saved locally in this browser while you play.'}
      </div>
    </div>
  );
}
